import React, { useState, useRef, useEffect } from "react";
import ClayLabel from "@clayui/label";
import DropDown from "@clayui/drop-down";
import { ClayCheckbox, ClayInput } from "@clayui/form";
import { UseFormRegister, FieldValues,FieldErrors } from "react-hook-form";
import './CustomMultiSelect.css'
interface Props {
  value: string[];
  handleOnChange: (e: string[]) => void;
  options: {
    key: string;
    name: string;
  }[];
  name: string;
  limit: number;
  register: UseFormRegister<FieldValues>;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  errors: FieldErrors<FieldValues>
  optionListObj: Record<string, string>;
  desc?:string
}

const CustomMultiSelect: React.FC<Props> = ({
  value,
  handleOnChange,
  options,
  name,
  placeholder,
  disabled,
  limit,
  errors,
  optionListObj,
  desc
}) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const [filteredOptions, setFilteredOptions] = useState(options);

  const isChecked = (item: string) => {
    return value.includes(item);
  };

  const handleSelect = (e: string) => {
    if (value.includes(e)) {
      handleOnChange(value.filter((item) => item != e));
    } else {
      if (value.length < limit) {
        setInputValue("");
        handleOnChange([...value, e]);
      }
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  useEffect(() => {
    if (inputValue) {
      setFilteredOptions(
        options.filter((option) =>
          option.name.toLowerCase().includes(inputValue.toLowerCase())
        )
      );
    } else {
      setFilteredOptions(options);
    }
  }, [inputValue, options]);

  return (
    <div
      ref={wrapperRef}
      className={`form-group ${disabled ? "Disabled" : ""}`}
    >
      <div
        className={`advanced__search__dropdown__container ${name}-adv-dropdown ${
          disabled ? "Disabled" : ""
        }`}
        onClick={() => {
          !disabled && value?.length < 3 ? setIsOpen(true) : setIsOpen(!isOpen);
        }}
      >
        <label htmlFor={name} className="custom_label">
          {placeholder}
          {desc ? <i className="i-font">{desc}</i>: null}
        </label>
        <ClayInput
          className="custom_input custom-select"
          id={name}
          name={name}
          disabled={disabled}
          placeholder={name === "primaryTarget" ? "Select countries" : `Select an option`}
          autoComplete="off"
          onChange={(e) => setInputValue(e?.target?.value)}
          type="text"
          value={inputValue && inputValue}
        />
      </div>
      {errors[name] && (
        <div className="invalid-feedback" style={{ display: "block" }}>
          {errors[name]?.message as string}
        </div>
      )}
      {isOpen ? (
        <div className="advanced__search__dropdown__menu">
          <DropDown.ItemList>
            {filteredOptions.map((item) => (
              <DropDown.Item key={item.key} className={isChecked(item.key) ? "list-item-active":""}>
                <ClayCheckbox
                  checked={isChecked(item.key)}
                  onChange={(e) => handleSelect(e.target.value)}
                  onClick={(e) => e.stopPropagation()}
                  value={item.key}
                  name={name}
                  label={item.name}
                  disabled={value.length >= limit && !isChecked(item.key)}
                />
              </DropDown.Item>
            ))}
          </DropDown.ItemList>
        </div>
      ) : null}
      <div className="my-2">
        {value?.length > 0 &&
          value.map((key, i) => (
            <ClayLabel
              key={key}
              displayType="info"
              className="custom-label"
              closeButtonProps={{
                "aria-label": "Close",
                title: "Close",
                onClick: () =>
                  handleOnChange(value.filter((val) => val !== key)),
              }}
            >
              {optionListObj[key]}
            </ClayLabel>
          ))}
      </div>
    </div>
  );
};

export default CustomMultiSelect;
